<template>
  <component :is="currentView" :active="active" ref="summaryComponent"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import { treeNodeSubType } from '@/constants/tree';
import WPerformanceServerSummary from './server';
import WPerformanceNetdeviceSummary from './netdevice';
import WPerformanceNetinterfaceSummary from './netinterface';
import WPerformanceDatabaseSummary from './database';
import WPerformanceSensorSummary from './sensor';
import WPerformanceE2ESummary from './e2e';
import WPerformanceServiceSummary from './service';
import WPerformanceVirtualSummary from './virtual';
import WPerformanceApmSummary from './apm';
import WPerformanceApControllerSummary from './ap-controller';
import WPerformanceWirelessApSummary from './wireless-ap';

export default {
  name: 'WPerformanceNodeSummary',
  components: {
    WPerformanceServerSummary,
    WPerformanceNetdeviceSummary,
    WPerformanceNetinterfaceSummary,
    WPerformanceDatabaseSummary,
    WPerformanceSensorSummary,
    WPerformanceE2ESummary,
    WPerformanceServiceSummary,
    WPerformanceVirtualSummary,
    WPerformanceApmSummary,
    WPerformanceApControllerSummary,
    WPerformanceWirelessApSummary,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      currentView: null,
      taskName: 'performanceNodeSummaryTask',
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(to, from) {
        if (this.currentView === null || to.treeKey !== from.treeKey) {
          // TODO: 트리 타입마다 treeKey가 같아도 다른 노드일 수 있음. 해당 부분 처리 추가 필요함.
          this.changeView();
        }
      },
    },
    active: {
      handler(flag) {
        if (flag) {
          this.$taskManager.startTask(this.taskName);
        } else {
          this.$taskManager.stopTask(this.taskName);
        }
        this.changeView();
      },
    },
    // $route(to, from) {
    //   const toMenu = to.path.split('/')[1];
    //   const fromMenu = from.path.split('/')[1];
    //
    //   if (toMenu !== fromMenu || to.params.treeKey !== from.params.treeKey) {
    //     this.changeView();
    //   }
    // },
  },
  created() {
    this.$taskManager.createTask(this.taskName, 60, this.taskLoadData, true);
    if (this.active) {
      this.$taskManager.startTask(this.taskName);
    }
  },
  beforeDestroy() {
    this.$taskManager.removeTask(this.taskName);
  },
  methods: {
    changeView() {
      if (this.active) {
        if (this.selectedNode.subType === treeNodeSubType.SERVER) {
          this.currentView = WPerformanceServerSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.NETDEVICE) {
          this.currentView = WPerformanceNetdeviceSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.NETINTERFACE) {
          this.currentView = WPerformanceNetinterfaceSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.DBMS) {
          this.currentView = WPerformanceDatabaseSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.SENSOR) {
          this.currentView = WPerformanceSensorSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.E2E) {
          this.currentView = WPerformanceE2ESummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.SERVICE) {
          this.currentView = WPerformanceServiceSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.VIRTUAL) {
          this.currentView = WPerformanceVirtualSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.APM) {
          this.currentView = WPerformanceApmSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.APM) {
          this.currentView = WPerformanceApmSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.APM) {
          this.currentView = WPerformanceApmSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.AP_CONTROLLER) {
          this.currentView = WPerformanceApControllerSummary.name;
        } else if (this.selectedNode.subType === treeNodeSubType.WIRELESS_AP) {
          this.currentView = WPerformanceWirelessApSummary.name;
        }
      }
    },
    taskLoadData() {
      this.$refs.summaryComponent.loadData(true);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/index.vue